module.exports = __webpack_public_path__ + "img/totalLoss.75f46cdd.png";